import { Box } from "@mui/material";
import AppImage from "./AppImage";
import { memo } from "react";
const AppNoData = () => {
  return (
    <Box className="text-center p-10 pt-[100px]">
      <AppImage
        src={"/images/no-data.png"}
        height={"auto"}
        width={"auto"}
        alt="không có kết quả"
      />
      <div className="mt-8 h2">Không tìm thấy kết quả nào</div>
    </Box>
  );
};

export default memo(AppNoData);
